import React from 'react';
import classes from './BuildControls.module.css'
import BuildControl from './BuildControl/BuildControl'

/**
 * Created by Doa on 24-7-2019.
 */
const controls = [
    {label: 'Salad', type: 'salad'},
    {label: 'Bacon', type: 'bacon'},
    {label: 'Cheese', type: 'cheese'},
    {label: 'Meat', type: 'meat'}
];

const buildControls = (props) => {

    const clear = props.purchasable ? <u className={classes.Clear}
                                         onClick={props.cleared}
    >clear</u> : null;

    return (
        <div className={classes.BuildControls}>
            <p>Current Price: <strong>{props.price.toFixed(2)} $ </strong>
                {clear}
            </p>
            {controls.map(ctrl => (
                <BuildControl key={ctrl.label}
                              label={ctrl.label}
                              added={() => props.ingredientAdded(ctrl.type)}
                              removed={() => props.ingredientRemoved(ctrl.type)}
                              disabled={props.disabled[ctrl.type]}/>
            ))}
            <button className={classes.OrderButton}
                    disabled={!props.purchasable}
                    onClick={props.ordered}
            >{props.isAuth ? 'Order Now' : 'Sign up to order'}
            </button>
        </div>
    );
};

export default buildControls;